(() => {
  'use strict';
  if (window.__abmiumCatalogueUI) return;
  window.__abmiumCatalogueUI = true;

  const ROOT = '[data-abm-catalogue]';

  function setFilterDrawer(root, open, returnFocus = false) {
    const filters = root?.querySelector('[data-abm-filters]');
    if (!filters) return;
    const button = root.querySelector('[data-abm-open-filters]');
    filters.classList.toggle('is-open', open);
    button?.setAttribute('aria-expanded', String(open));
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (!open && returnFocus) button?.focus?.({ preventScroll: true });
  }

  async function quickAdd(form, root) {
    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;
    const original = button.textContent;
    button.disabled = true;
    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error(String(response.status));
      const cartUrl = root?.dataset?.cartJsonUrl || '/cart.js';
      const cart = await fetch(cartUrl, { credentials: 'same-origin' }).then(result => result.json());
      document.dispatchEvent(new CustomEvent('abmium:cart', { detail: { count: cart.item_count } }));
      button.textContent = root?.dataset?.addedLabel || 'Added';
      setTimeout(() => { button.textContent = original; }, 1400);
    } catch (_) {
      form.submit();
    } finally {
      button.disabled = false;
    }
  }

  document.addEventListener('submit', event => {
    const form = event.target?.closest?.('[data-abm-quick-add]');
    const root = form?.closest?.(ROOT);
    if (!form || !root || event.defaultPrevented) return;
    event.preventDefault();
    quickAdd(form, root);
  });

  document.addEventListener('click', event => {
    const root = event.target?.closest?.(ROOT);
    if (!root) return;
    const control = event.target.closest('[data-abm-open-filters], [data-abm-close-filters]');
    if (!control) return;
    event.preventDefault();
    setFilterDrawer(root, control.hasAttribute('data-abm-open-filters'), control.hasAttribute('data-abm-close-filters'));
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const root = event.target?.closest?.(ROOT) || document.querySelector(ROOT);
    if (!root?.querySelector('[data-abm-filters].is-open')) return;
    event.preventDefault();
    setFilterDrawer(root, false, true);
  });
})();